
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X, Download } from 'lucide-react';

interface InstallPwaPromptProps {
  onClose: () => void;
}

const InstallPwaPrompt: React.FC<InstallPwaPromptProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg animate-fade-in">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-neobank-dark">Install CoinPrime</h3>
          <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8">
            <X className="h-4 w-4" />
          </Button>
        </div>
        
        <div className="mb-6">
          <p className="mb-3 text-gray-600">Install CoinPrime on your home screen for quick access and fullscreen experience.</p>
          
          <div className="bg-gray-100 p-3 rounded-md mb-4">
            <ol className="list-decimal list-inside text-sm text-gray-700 space-y-2">
              <li>Tap the Share button <span className="inline-block px-2 py-1 mx-1 bg-gray-200 rounded">􀈂</span> at the bottom of the browser</li>
              <li>Scroll down and select "Add to Home Screen"</li>
              <li>Confirm by tapping "Add"</li>
            </ol>
          </div>
        </div>
        
        <div className="flex gap-3">
          <Button 
            onClick={onClose} 
            variant="outline" 
            className="flex-1"
          >
            Skip
          </Button>
          <Button 
            className="flex-1 bg-neobank-primary hover:bg-neobank-primary/90"
            onClick={onClose}
          >
            <Download className="mr-2 h-4 w-4" />
            Install
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InstallPwaPrompt;
